import * as React from 'react';
import { Row } from 'antd';

import Templates, { ITemplateEditorProps } from "./Templates";
import BannerPreviewer from "./BannerPreviewer"
import { rl } from "../../store/banner/editor/reducers";
import { user } from "../../store/banner/editor/user"
import SplitPane from "react-split-pane";
import debounce from "debounce-promise"

import styles from './BannerEditor.module.less'
import BannerPreviewerContainer from "../../containers/BannerPreviewerContainer";
import { IFeedState } from "../../store/feed/types";

interface IOwnProps {
    template: string;
    originalTemplate: string;
    masterTemplate?: string;
    templateDiffMode?: boolean;
    diffEditorReadOnly?: boolean
    customCode: string;
    feed: IFeedState;
    title?: string;
}

interface ICallbackProps {
    onTemplateChange?: (newValue: string) => void;
    onCustomCodeChange?: (newValue: string) => void;
    onOutputChange?: (newValue: string) => void;
}


type IProps = IOwnProps & ICallbackProps;

interface IState {
    colSize: number;
    output: string;
}

// todo fix the cancellation, this doesn't need to be promise indeed.
const parseTemplateAPIDebounced = debounce((template, user, customCode) => {
    try {
        return Promise.resolve(rl.Parse(template, user, customCode))
    } catch (e: any) {
        return Promise.resolve(e.toString())
    }
}, 1000, { leading: true });

class BannerEditor extends React.PureComponent<IProps, IState> {
    state: IState;

    constructor(pros: IProps) {
        super(pros);
        this.state = {
            colSize: 0,
            output: ""
        }
    }

    componentDidMount(): void {
        this.parseTemplate()
    }

    componentDidUpdate(prevProps: Readonly<IOwnProps & ICallbackProps>, prevState: Readonly<IState>, snapshot?: any): void {
        if (prevProps.customCode !== this.props.customCode
            || prevProps.template !== this.props.template
            || Object.keys(prevProps.feed.liveFeeds.byId).length !== Object.keys(this.props.feed.liveFeeds.byId).length
        ) {
            this.parseTemplate()
        }
    }

    parseTemplate = async () => {
        const result = await parseTemplateAPIDebounced(this.props.template, user, this.props.customCode)
        if (this.state.output !== result) {
            this.setState({ output: result });
            if (this.props.onOutputChange) {
                this.props.onOutputChange(result);
            }
        }
    };

    onTemplateChange = (value: string, event: any) => {
        if (this.props.onTemplateChange) {
            this.props.onTemplateChange(value);
        }
    };

    onTemplateDiffChange = (value: string) => {
        if (this.props.onTemplateChange) {
            this.props.onTemplateChange(value);
        }
    };

    onCustomCodeChange = (value: string, event: any) => {
        if (this.props.onCustomCodeChange) {
            this.props.onCustomCodeChange(value);
        }
    };

    preview = () => {
        this.parseTemplate()
    };

    onResize = (newSize: number) => {
        this.setState({
            colSize: newSize
        })
    };

    render() {
        // console.log("BannerEditor render........");
        const output = this.state.output
        let templateEditorProps: ITemplateEditorProps = {
            value: this.props.template,
            original: this.props.originalTemplate,
            diffMode: this.props.templateDiffMode || false,
            onChange: this.onTemplateChange,
            onDiffChange: this.onTemplateDiffChange,
            size: this.state.colSize,
            diffEditorProps: {
                options: {
                    readOnly: this.props.diffEditorReadOnly
                }
            }
        };
        let previewProps = {
            output: output
        }
        return (
            <Row className={styles.bannerEditor}>
                <SplitPane
                    split="vertical"
                    minSize={0}
                    maxSize={-13}
                    defaultSize={"65%"}
                    onDragFinished={this.onResize}
                    pane1Style={{ paddingRight: "10px", height: "100%" }}
                    pane2Style={{ paddingLeft: "10px", width: "100%", height: "100%", overflow: "scroll" }}
                >
                    <div>
                        {this.props.title && <h1>{this.props.title}</h1>}
                        <Templates
                            templateEditorProps={templateEditorProps}
                            customCode={this.props.customCode}
                            codeEditorLayout={this.state.colSize}
                            output={output}
                            onCustomCodeChange={this.onCustomCodeChange}
                            preview={this.preview}
                        />
                    </div>
                    <BannerPreviewerContainer {...previewProps} />
                </SplitPane>
            </Row>
        )
    }
}

export default BannerEditor